
<template>

  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="fixed z-[9999] inset-x-0 top-0  flex items-start pointer-events-none">
    <div class="w-full flex flex-col items-center px-2 space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition 
        enter-active-class="transform ease-out duration-300 transition" 
        enter-from-class="translate-y-[-100%] opacity-0" 
        enter-to-class="translate-y-0 opacity-100" 
        leave-active-class="transform transition ease-in duration-200" 
        leave-from-class="translate-y-0 opacity-100" 
        leave-to-class="translate-y-[-100%] opacity-0">
        <div v-if="show" class="w-full bg-gradient-to-r from-indigo-900 to-purple-900 shadow-xl rounded-b-xl pointer-events-auto border-b border-indigo-700 overflow-hidden">
          <div class="p-2">
            <div class="flex items-center">
              <div class="flex-shrink-0 bg-green-500 bg-opacity-20 p-2 rounded-full">
                <CheckCircleIcon class="h-7 w-7 text-green-400" aria-hidden="true" />
              </div>

              <div class="ml-4 w-0 flex-1 text-white">
                <div class="text-base font-medium flex gap-8 justify-between items-center">
                    <div class="flex items-center">
                        <span class="bg-white bg-opacity-20 px-3 py-1 rounded-full text-sm font-semibold">
                          {{selected}}
                        </span>
                        <span class="ml-2">itens selecionados</span>
                    </div>

                    <div class="flex gap-6">
                        <div @click="remove" class="cursor-pointer hover:text-red-300 transition-colors duration-200 flex items-center gap-1">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                          Remover
                        </div>
                        <div @click="cancel" class="cursor-pointer hover:text-indigo-300 transition-colors duration-200 flex items-center gap-1">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          Cancelar
                        </div>
                    </div>
                </div>
              </div>

              <div class="ml-4 flex-shrink-0 flex">
                <button @click="cancel" class="rounded-full p-1 inline-flex text-white hover:bg-white hover:bg-opacity-20 transition-colors duration-200 focus:outline-none">
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>

import { CheckCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline'


export default {
    name: 'Tools',
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        selected: {
            type: Number,
        },
        cancel: {
            type: Function,
        },
        remove: {
            type: Function,
        },
    },

    data() {
        return {
            
        }        
    },

    components: {
        CheckCircleIcon,
        XMarkIcon,
    },
}
</script>
